import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

export function PriceAnchor() {
  return (
    <section className="py-16 bg-slate-950">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <p className="text-slate-400 text-sm font-medium uppercase tracking-widest mb-3">The cost of getting unstuck</p>
          <h2 className="text-3xl sm:text-4xl font-heading font-bold text-white">
            Coaching doesn't have to cost a fortune.
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6">
          <div className="bg-slate-800/60 border border-slate-700/50 rounded-2xl p-6 sm:p-7 text-center">
            <p className="text-slate-400 text-sm font-medium mb-3 leading-snug">Human life coach</p>
            <p className="text-4xl font-heading font-bold text-slate-300">$200</p>
            <p className="text-slate-500 text-sm mt-1">per month</p>
            <p className="text-slate-500 text-xs mt-3 leading-relaxed">Schedule weeks out. One hour a week if you're lucky.</p>
          </div>

          <div className="bg-slate-800/60 border border-slate-700/50 rounded-2xl p-6 sm:p-7 text-center">
            <p className="text-slate-400 text-sm font-medium mb-3 leading-snug">Therapy session</p>
            <p className="text-4xl font-heading font-bold text-slate-300">$150</p>
            <p className="text-slate-500 text-sm mt-1">per session</p>
            <p className="text-slate-500 text-xs mt-3 leading-relaxed">Valuable — but not always what you need to move forward.</p>
          </div>

          <div className="bg-gradient-to-b from-coral-500/20 to-coral-500/5 border-2 border-coral-500/40 rounded-2xl p-6 sm:p-7 text-center relative pt-10">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-coral-500 text-white text-xs font-bold px-3 py-1 rounded-full whitespace-nowrap">
              VZMO
            </div>
            <p className="text-white text-sm font-medium mb-3 leading-snug">AI coaching</p>
            <p className="text-4xl font-heading font-bold text-white">$9</p>
            <p className="text-coral-300 text-sm mt-1">per month</p>
            <p className="text-slate-400 text-xs mt-3 leading-relaxed">Unlimited sessions. Available right now. No scheduling.</p>
          </div>
        </div>

        <div className="mt-8 text-center">
          <Link
            to="/signup"
            className="inline-flex items-center gap-2 bg-coral-500 hover:bg-coral-600 text-white font-semibold px-6 py-3 rounded-xl transition-colors shadow-lg shadow-coral-500/25"
          >
            Try it free
            <ArrowRight className="h-4 w-4" />
          </Link>
          <p className="text-slate-500 text-sm mt-3">No credit card required. Free plan available.</p>
        </div>
      </div>
    </section>
  );
}
